import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

import { ILink } from "../models/link.model";
import { Location } from "../utilities/location";

@Component({
	selector: "nav-pills",
	template: `
		<ul class="nav nav-pills nav-pills-nobg {{clases}}" role="tablist">
			<li role="presentation" *ngFor="let item of links; let i = index" [ngClass]="liClass(item)">
        <ng-container *ngIf="!item.hide"><a (click)="navigate(item)" [attr.data-automation-nav-pills-item-a]="i">{{item.name}}</a></ng-container>
			</li>
		</ul>
`})
export class NavPillsComponent {
	@Input() links: ILink[];
	@Input() clases: string;

	constructor(private router: Router) { }

	liClass(item: ILink) {
		return {
			"active": Location.isActiveLink(item.link),
			"disabled": item.disabled
		};
	}
	navigate(item: ILink) {
		if (!item.disabled && item.link) {
			this.router.navigate([item.link]);
		}
	}
}
